import React, { memo } from 'react';
import PropTypes from 'prop-types';
import * as TablerIcons from '@tabler/icons-react';

const iconComponentCache = new Map();

const toPascalCase = (name) => name
    .trim()
    .split(/[-_ ]+/)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join('');

const resolveIcon = (name) => {
    if (iconComponentCache.has(name)) {
        return iconComponentCache.get(name);
    }

    const IconComponent = TablerIcons[`Icon${toPascalCase(name)}`] || null;
    iconComponentCache.set(name, IconComponent);
    return IconComponent;
};

const PgIcon = ({ name, size, weight, color, className, ...props }) => {
    const IconComponent = resolveIcon(name);

    if (!IconComponent) {
        if (process.env.NODE_ENV !== 'production') {
            console.warn(`PgIcon: no Tabler icon found for name "${name}"`);
        }
        return null;
    }

    return (
        <IconComponent
            size={size}
            stroke={weight}
            color={color}
            className={className}
            {...props}
        />
    );
};

PgIcon.propTypes = {
    /** Tabler icon slug, e.g. "circle-check", "chevron-right", "trash". */
    name: PropTypes.string.isRequired,
    size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    /** Stroke width — Tabler calls this `stroke`, exposed here as `weight`. */
    weight: PropTypes.number,
    color: PropTypes.string,
    className: PropTypes.string,
};

PgIcon.defaultProps = {
    size: 24,
    weight: 1.5,
    color: 'currentColor',
};

export default memo(PgIcon);
